import styled from "@emotion/styled";

export const AcknowledgementGroupContainer = styled.div(({ theme }) => ({
	marginLeft: "16px",
	"& > span": {
		fontWeight: 500,
		letterSpacing: "0.17px",
		lineHeight: 1.4,
		marginBottom: "8px",
		color: theme.project.colors.fontColors.secondary
	}
}));

export const RadioGroupContainer = styled.div({ padding: "0 24px" });

export const PreviewWrapper = styled.div({
	marginLeft: "20px",
	marginBottom: "16px"
});
